import { convertAnalysisAttributeToUnit, FieldViewModel, getMorganIndexTextFromValue, getSoilUnitLabel, IOmniaShellDialogOptions, isUndefinedOrNull, models, SoilAnalysisType, soilColors, SoilP2O5Method, SoilUnit } from "../../omnia"
import { IAnalysisEditCommand, IAnalysisValueColumn } from "../../types"
import { IDashboardContext } from "../types"
import { SoilAnalysisVM } from "./soil-vm"

export function selectSoilAnalysis(context: IDashboardContext, a: SoilAnalysisVM, field: FieldViewModel, element?: string) {

    const map = context.map

    map.selectView("S", element)

    let zone = a.zone ? map.getZoneFromCurrentView(a.zone.DataLayerZoneId) : null
    context.setSelectedField(field, zone, true)

}

export function editSoilAnalysis(context: IDashboardContext, type: SoilAnalysisType, vm: SoilAnalysisVM, field: FieldViewModel) {

    type = isUndefinedOrNull(type) && vm?.analysis
        ? vm.analysis.Type
        : type

    const [component, options] = type == SoilAnalysisType.SSM
        ? [
            "omnia-soil-editor-ssm-popup", {
                size: "full-screen"
            } as IOmniaShellDialogOptions]
        : ["omnia-soil-editor-soil-popup", undefined]

    const cmd: IAnalysisEditCommand = {
        analysis: vm ? vm.analysis : null,
        edit: true,
        context: null,
        alloc: field
    }

    context.showDialog(component, cmd, options)

}


export function getTableContext(unitProvider: () => SoilUnit) {

    return {

        getTableColumnUnits(c: IAnalysisValueColumn) {
            return (c.morgan || c.index)
                ? getSoilUnitLabel(unitProvider(), c)
                : c.units
        },

        getTableCellValue(c: IAnalysisValueColumn, a: SoilAnalysisVM) {

            if (!a.hasAnalysisValue(c)) {
                return
            }

            const unit = unitProvider()

            if ((unit === SoilUnit.Index) && c.index) {
                return getAnalysisIndex(c, a)
            }

            if (c.morgan) {
                return convertAnalysisAttributeToUnit(a.analysis, c.name, unit)
            }

            return a.getAnalysisValue(c)

        },

    }

}

export function getAnalysisIndex(c: IAnalysisValueColumn, vm: SoilAnalysisVM) {

    const sa = vm?.analysis
    const value = vm.getAnalysisValue(c)
    const key = c.key || c.name

    if (c.morgan && (sa?.P2O5Method == SoilP2O5Method.Morgan)) {
        return getMorganIndexTextFromValue(key as any, value)
    }

    return soilColors.getValueIndex(value, c.key || c.name)

}
